/**
 * Returns the number of characters visible by the given text. (useful when the text contains HTML tags)
 * @param text
 * @returns {*}
 */
export const calculateVisibleText = text => {
  if (!text) return 0;
  if (typeof text !== 'string') return 0;

  const element = document.createElement('div');
  // eslint-disable-next-line no-unsafe-innerhtml/no-unsafe-innerhtml
  element.innerHTML = text;
  return element.textContent
    ? element.textContent.length
    : element.innerText
      ? element.innerText.length
      : 0;
};

/**
 * Returns the text after it has been reduced to maximum char length as specified by textMaxLength. This function retains the HTML tags and cuts the text between tags.
 * @param text
 * @param textMaxLength
 * @returns {*}
 */
export const removeVisibleText = (text, textMaxLength) => {
  if (!text) return text;
  if (isNaN(textMaxLength)) return text;
  if (textMaxLength >= text) return text;

  let res = '';
  const element = document.createElement('div');
  // eslint-disable-next-line no-unsafe-innerhtml/no-unsafe-innerhtml
  element.innerHTML = text;
  const textArray = Array.prototype.map.call(element.childNodes, node => node.textContent);
  const htmlNodesArray = Array.prototype.map.call(element.childNodes, node => node.outerHTML);

  let totalLength = 0;
  for (let i = 0; i < textArray.length; i++) {
    let textChunk = textArray[i];
    totalLength += i > 0 ? textArray[i - 1].length : totalLength;
    if (textMaxLength - totalLength <= 0) break;

    if (!htmlNodesArray[i]) {
      if (totalLength + textChunk.length <= textMaxLength) {
        res += textChunk;
      } else {
        res += textChunk.substring(0, textMaxLength - totalLength);
        break;
      }
    } else {
      if (totalLength + textChunk.length <= textMaxLength) {
        res += htmlNodesArray[i];
      } else {
        textChunk = htmlNodesArray[i];
        const splitValues = textChunk.split(/(<.*?>)/).filter(x => x);
        const innerText = splitValues[1];
        res +=
          splitValues[0] + innerText.substring(0, textMaxLength - totalLength) + splitValues[2];
        break;
      }
    }
  }

  return res;
};
